module.exports = __webpack_public_path__ + "static/img/Walking Tours.12aaa28.png";